import {
  Button,
  ModalActions,
  ModalContent,
  ModalHeader,
  Text,
} from '@lightspeed/design-system-react'
import { ApiRetailerPaymentType } from '@vend/types'
import React, { FC } from 'react'
import { useT } from '@transifex/react'
import { usePaymentManager } from '../../../../../../ng-compat/hooks'
import { Transaction } from '../../queries/Transaction'

interface Props {
  onDecline: () => void
  onComplete: () => void
  retailerPaymentType: ApiRetailerPaymentType
  transaction: Transaction
}

export const PrintSignatureReceipt: FC<Props> = ({
  onDecline,
  onComplete,
  retailerPaymentType,
  transaction,
}) => {
  const t = useT()
  const paymentManager = usePaymentManager()
  const printSignatureReceipt = () => {
    paymentManager.emit('printReceipt', {
      isSignatureSlipReceipt: true,
      paymentType: retailerPaymentType,
      transaction: {
        tenders: transaction.tenders.map(tender => ({
          amount: tender.amount,
          type: tender.type,
          created_at: tender.createdAt,
          external_transaction_id: tender.externalTransactionID,
          card_details: {
            card: {
              last_four: tender.cardDetails.card.lastFour,
            },
          },
          provider_fields: tender.providerFields,
        })),
      },
    })
    onComplete()
  }

  return (
    <>
      <ModalHeader>
        {t('Confirm customer signature to accept payment.', {
          _context:
            'The payment prompt header indicates that the user should confirm the customer signature to accept the payment',
        })}
      </ModalHeader>
      <ModalContent>
        <Text tag="p">
          {t(
            'Print a copy of the receipt for the customer to sign so you can confirm their signature.',
            {
              _context:
                'The payment prompt description instructs the user to print a receipt for the customer to sign in order to confirm their signature.',
            }
          )}
        </Text>
      </ModalContent>
      <ModalActions>
        <div className="vd-btn-group">
          <Button
            data-track="decline-print-signature"
            variant="supplementary"
            onClick={onDecline}
          >
            {t('Decline', {
              _context: 'Button label for declining',
            })}
          </Button>
          <Button
            data-track="print-signature-receipt"
            variant="go"
            onClick={printSignatureReceipt}
          >
            {t('Print Signature Receipt', {
              _context: 'Button label for printing signature receipt',
            })}
          </Button>
        </div>
      </ModalActions>
    </>
  )
}
